(function () {
  const els = document.querySelectorAll('.product-story__animate');
  if (els.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const delay = parseInt(entry.target.dataset.index || 0) * 80;
          setTimeout(() => entry.target.classList.add('is-visible'), delay);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => observer.observe(el));
  }

  document.querySelectorAll('.product-story__image').forEach((img) => {
    img.addEventListener('click', () => {
      img.classList.toggle('zoomed');
    });
  });
})();